(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-quick-info/assets/javascripts/casino-quick-info.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-quick-info/assets/javascripts/casino-quick-info.js');

'use strict';

const ReactBottomSheet = svs.ui.ReactBottomSheet;
const CasinoGamePreview = svs.components.casino_react.casinoGamePreview.CasinoGamePreview;
const CasinoQuickInfo = _ref => {
  let gameModel = _ref.gameModel,
    imageSource = _ref.imageSource,
    showQuickInfoModal = _ref.showQuickInfoModal,
    toggleQuickInfo = _ref.toggleQuickInfo;
  return React.createElement(ReactBottomSheet.BottomSheet, {
    allowHeaderSwipe: true,
    behavior: "hybrid",
    className: "casino-preview-game-info",
    disablePageContentSpacing: true,
    inverted: true,
    isExpanded: showQuickInfoModal,
    isVisible: showQuickInfoModal,
    onStateChange: _ref2 => {
      let state = _ref2.state;
      if (state === ReactBottomSheet.BottomSheetConstants.STATE_COLLAPSED) {
        toggleQuickInfo();
      }
    }
  }, React.createElement(CasinoGamePreview, {
    gameModel: gameModel,
    imageSource: imageSource,
    isVisableFromBottomSheet: true
  }));
};
setGlobal('svs.components.casino_react.CasinoQuickInfo', CasinoQuickInfo);

 })(window);